<template>
  <div>
    <v-icon small class="mr-2" @click="dialog = true"> mdi-eye </v-icon>
    <v-dialog v-model="dialog">
      <v-card v-if="story">
        <v-card-title>
          {{ story.name }}
        </v-card-title>
        <v-card-text class="text-left">
          <v-alert type="success" v-if="story.status._id == 'Published'"
            >{{ story.status._id }}
          </v-alert>
          <v-alert type="warning" v-if="story.status._id == 'In Review'"
            >{{ story.status._id }}
          </v-alert>
          <v-alert type="info" v-if="story.status._id == 'Draft'"
            >{{ story.status._id }}
          </v-alert>
          <v-alert type="error" v-if="story.status._id == 'Archived'"
            >{{ story.status._id }}
          </v-alert>
          <h1>{{ $t("admin.owner") }}</h1>
          <h2>{{ $t("admin.ownerEmail") }}</h2>
          <p>{{ story.owner.email }}</p>
          <h2>{{ $t("admin.ownerUsername") }}</h2>
          <p>{{ story.owner.userProfile.username }}</p>
          <v-divider />
          <h1>{{ $t("storyHub.basicInfo.basicInfo") }}</h1>
          <v-alert type="error" v-if="needsReview(story.updatedAt)">{{ $t('admin.needsReviewUpdatedAt', { date: story.updatedAt}) }} </v-alert>
          <h2>{{ $t("story.title") }}</h2>
          <p>{{ story.name }}</p>
          <h2>{{ $t("story.description") }}</h2>
          <p v-html="story.description"></p>
          <h2>{{ $t("story.genre") }}</h2>
          <p>{{ story.genre._id }}</p>
          <h2>{{ $t("story.ageRating") }}</h2>
          <p>{{ story.ageRating._id }}</p>
          <h2>{{ $t("story.tagline") }}</h2>
          <p>{{ story.summary }}</p>
          <h2>{{ $t("story.tags") }}</h2>
          <v-chip v-for="tag in story.tags" :key="tag.id">{{ tag._id }}</v-chip>
          <h2>{{ $t("story.duration") }}</h2>
          <p>{{ story.duration }}</p>
          <v-divider />
          <h1>{{ $t("chapter.connections")}}</h1>
          <div v-for="chapter in story.chapters" :key="chapter.id">
            <h2>{{ chapter ? chapter.name : "" }}</h2>
            <v-alert
              type="error"
              v-if="needsReview(chapter.updatedAt)"
            >
              {{ $t('admin.needsReviewUpdatedAt', { date: chapter.updatedAt}) }}
            </v-alert>
            <div v-if="chapter.chapterConnectors.length > 0">
              <p v-for="chapterConnector in chapter.chapterConnectors" :key="chapterConnector.id">
                <v-icon color="success">mdi-arrow-right-thin-circle-outline</v-icon>
                {{ chapterConnector.name ? '"' + chapterConnector.name + '" - ' : null}}
                <strong>
                  {{ chapterConnector.toChapter ? chapterConnector.toChapter.name : "[Destination chapter not set]" }}
                </strong>
              </p>
            </div>
            <div v-else>
              <p>
              No connections
              </p>
            </div>
          </div>
          <v-divider />
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="chapter in story.chapters" :key="chapter.id">
              {{ chapter.name }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="chapter in story.chapters" :key="chapter.id">
              <v-card flat>
                <v-alert type="error" v-if="needsReview(chapter.updatedAt)">{{ $t('admin.needsReviewUpdatedAt', { date: chapter.updatedAt}) }}  </v-alert>
                <v-card-text v-html="chapter.text"></v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-btn color="blue darken-1" text @click="dialog = false">
          {{ $t("forms.cancel") }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import gql from "graphql-tag";
export default {
  props: {
    storyId: String,
    compareDateString: String,
  },
  data() {
    return {
      dialog: false,
      tab: null,
      compareDate: this.compareDateString ? new Date(this.compareDateString) : null,

    };
  },
  apollo: {
    story: {
      query: gql`
        query GetStory($id: ID!) {
          story(id: $id) {
            id
            name
            description
            summary
            statusUpdatedAt
            updatedAt
            status {
              id
              _id
            }
            duration
            genre {
              id
              _id
            }
            ageRating {
              id
              _id
            }
            tags {
              id
              _id
            }
            owner {
              id
              email
              userProfile {
                id
                username
              }
            }
            chapters {
              id
              name
              text
              updatedAt
              chapterConnectors {
                id
                name
                toChapter {
                  id
                  name
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.storyId,
        };
      },
      skip() {
        return !this.dialog;
      },
    },
  },
  methods: {
    needsReview(dateString) {
      if (this.compareDate){
        const date = new Date(dateString);
        if (date.getTime() > this.compareDate.getTime()) {
          return true
        }
      }
      return false
    }
  }
};
</script>
<style scoped>
.v-divider {
  margin: 1rem 0;
}
h1 {
  margin-bottom: 1rem;
}
</style>